export class ErrorAppUpdate extends Error {
  constructor(msg) {
    super(msg);
  }
}